import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'ghost' | 'accent';

const styles: Record<Variant, string> = {
  primary: 'bg-brand text-white hover:bg-brand-dark',
  accent: 'bg-accent text-white hover:brightness-95',
  ghost: 'border border-slate-200 bg-white text-slate-600 hover:bg-slate-50',
};

export function Button({
  children,
  variant = 'primary',
  className = '',
  icon,
  ...rest
}: {
  children: ReactNode;
  variant?: Variant;
  icon?: ReactNode;
  className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-1.5 rounded-lg px-3.5 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${styles[variant]} ${className}`}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
